import React from 'react';

import getRedirectUrl from 'registration/helpers/getRedirectUrl';

type RedirectPageProps = {
  intent: string;
};
const RedirectPage = ({ intent }: RedirectPageProps) => {
  React.useEffect(() => {
    window.location.replace(
      new URL(getRedirectUrl(intent), window.location.origin)
    );
  }, [intent]);

  return null;
};

export default RedirectPage;
